import React from "react";
import { Box, TextField } from "@mui/material";
import Api from "../../Api/Api";

export default function CustomerEditInput(props) {
  const { id, value, api } = props;

  const [inputValue, setInputValue] = React.useState(value || "");
  const [suggestions, setSuggestions] = React.useState([]);

  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }

    try {
      const res = await Api.get(
        `/dashboard/search-customer?q=${encodeURIComponent(query)}`,
      );

      const list = Array.isArray(res.data) ? res.data : res.data?.data || [];

      setSuggestions(list);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelect = async (selected) => {
    try {
      const isTemp = String(id).startsWith("temp-");
      const rowId = String(id).replace("temp-", "");
      if (isTemp) {
        // ✅ JUST UPDATE UI (NO API)
        api.updateRows([
          {
            id,
            customer_name: selected,
          },
        ]);

        api.setEditCellValue({
          id,
          field: "customer_name",
          value: selected,
        });

        return;
      }

      const res = await Api.post("/dashboard/update-customer", {
        row_id: rowId,
        customer_name: selected,
      });

      const franchiseName = res.data.franchise_name || "";

      api.updateRows([
        {
          id,
          customer_name: selected,
          franchise_name: franchiseName,
        },
      ]);

      api.setEditCellValue({
        id,
        field: "customer_name",
        value: selected,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        variant="standard"
        value={inputValue}
        autoFocus
        fullWidth
        onChange={(e) => {
          const val = e.target.value;
          setInputValue(val);
          fetchSuggestions(val);
        }}
      />

      {suggestions.length > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            background: "#ffffff",
            border: "1px solid #ccc",
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 9999,
          }}
        >
          {suggestions.map((item, i) => (
            <Box
              key={i}
              sx={{
                padding: "2px",
                cursor: "pointer",
                "&:hover": { background: "#e7e7e7" },
              }}
              onClick={() => {
                setInputValue(item);
                setSuggestions([]);
                handleSelect(item);
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
